import request from './request.js';

/**
 *
 * @param userID
 * @param body
 * @returns {Promise<unknown>}
 */
function sendForgotPasswordEmail(userID, body) {
    const options = {
        endpoint: `/user/${ userID }/dependents/sendForgotPasswordEmail`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    sendForgotPasswordEmail
};